import { ORDER_TYPE_TRANSFER } from '../../constants';
import { CheckoutState } from '../../state';
import { getOrderType, hasExistingOrder } from './typedOrderSelectors';

export const getIsTransferredOrder = (state: CheckoutState) =>
    hasExistingOrder(state) && getOrderType(state) === ORDER_TYPE_TRANSFER;
